export const PHONE_NUMBER_LENGTH = 11
export const PASSWORD_LENGTH = 8
export const PIN_LENGTH = 4
export const REGEX_PHONE = /^\d{11}$/
export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/i
export const REGEX_PASSWORD = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+={[}\]|\\:;"'<,>.?/`~-]*$/i // must contain alphanumeric and optional special characters
export const REGEX_LETTER = /^[a-zA-Z]+$/ // alphabet (just a word)
export const REGEX_FULLNAME = /^[a-zA-Z ]+$/ // alphabet (just a word)